import {
  Container,
  CssBaseline,
  Box,
  TextField,
  Button,
  Paper,
} from "@mui/material";
import { useState } from "react";
import { UseRoleContext } from "../../../utils/RoleContext";
import { useNotification } from "../../../utils/NotifContext";
import { loginError } from "../../../notifText";



const Login = () => {
  const notifier = useNotification()
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const context = UseRoleContext()
  const handleLogin = async () => {
    if (email && password) {

      if (email === "tinasoa" && password === "tinasoa1212") {
        context.seConnecter({
          userId: 1,
          employeId: 1,
          matricule: "1",
          codeBarre: "1",
          nom: "Tinasoa",
          prenom: "Tinasoa",
          pole: "Region",
          poste: "Manager",
          nomRole: "Admin",
          Token: "3150a86919cd023682d56c5c576e446df9931398",
          prenomUsuel: "Admin"
        })
      }

      else {
        notifier({ ...loginError, title: "login Error", message: " verifier le login et/ou mot de passe" })
      }
    } else {
    }
  };



  return (
    <>
      <Container maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
       
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Paper sx={{ p: 2, backgroundColor: "rgba(255, 255, 255, 0.81)" }}>


         
            <img
              src="logo.png"
              alt="logo parera"
              loading="lazy"
            />

            <Box sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="login"
                name="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField
                margin="normal"
                required
                fullWidth
                id="password"
                name="password"
                label="Mot de passe"
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />

              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleLogin}
              >
                Login
              </Button>
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default Login;